import React from "react";
import { BrowserRouter as Router, Route, Routes, NavLink } from "react-router-dom";
import { AppBar, Toolbar, Typography, Container, Button, Box } from "@mui/material";
import { Contact } from "./components/ContactUs";
import { Services } from "./components/Services";
import { About } from "./components/About";
import { Home } from "./components/Home";

const App = () => {
  return (
    <Router>
      <Box sx={{ flexGrow: 1 }}>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" sx={{ flexGrow: 1 }}>Pest Control Raipur Services</Typography>
            <Button color="inherit" component={NavLink} to="/">Home</Button>
            <Button color="inherit" component={NavLink} to="/about">About</Button>
            <Button color="inherit" component={NavLink} to="/services">Services</Button>
            <Button color="inherit" component={NavLink} to="/contact">Contact</Button>
          </Toolbar>
        </AppBar>
        
        <Container sx={{ mt: 4 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Container>
        <Box sx={{ bgcolor: "#333", color: "white", textAlign: "center", py: 2, mt: 4, position: "fixed", bottom: 0, width: "100%" }}>
          <Typography>&copy; 2025 Pest Control Raipur Services. All rights reserved.</Typography>
        </Box>
        ...
      </Box>
    </Router>
  );
};

export default App;
